export default __webpack_public_path__ + "static/media/deletebin.155fdfb5.svg";